module.exports = __webpack_public_path__ + "img/advertising.af794d9f.png";